if (typeof window.whatToExpect === 'undefined') {
  window.whatToExpect = class whatToExpect {
    constructor(parent) {
      if(!parent) {
        return;
      }

      this.parent = parent;
      this.init();
    }

    clickEvent = () => {
      let parent = this.parent;
      let whatExpectTab = parent.querySelectorAll('.what-expect-tab-item-link');
      let whatExpectContent = parent.querySelectorAll('.what-expert-tab-content');

      whatExpectTab.forEach(tab => {
        tab.addEventListener('click', (e) => {
          let that = e.currentTarget;
          whatExpectTab.forEach(element => {
            element.closest('.what-expect-tab-item').classList.remove('current');
          });
          that.closest('.what-expect-tab-item').classList.add('current');
          const target = that.closest('.what-expect-tab-item').getAttribute('data-tab-heading');
          whatExpectContent.forEach(element => {
            element.classList.remove('current');
          });
          parent.querySelector(`.what-expert-tab-content[data-tab-content="${target}"]`) && parent.querySelector(`.what-expert-tab-content[data-tab-content="${target}"]`).classList.add('current');
        })
      });
    }

    init = () => {
      this.clickEvent();
    }
  }
}

document.querySelectorAll('.section--what-to-expect:not([data-what-to-expect-initialized])').forEach(section => {
  section.setAttribute('data-what-to-expect-initialized', 'true');
  new window.whatToExpect(section);
});
